import { useParams } from "react-router-dom";
import { Construction } from "lucide-react";
import { label } from "../lib/format";
import { PageHeader } from "../components/common/UI";

const PHASE = {
  referrals: 3, hearings: 3, "committee-reports": 3, "session-calendar": 3, "session-agenda": 3, attendance: 3, "motions-and-voting": 3,
  "minutes-and-journals": 3, "executive-actions": 4, "external-review": 4, publication: 4, calendar: 4, archive: 5, "public-portal": 5, reports: 6, retention: 5,
};

export default function ComingSoon() {
  const { slug } = useParams();
  return (
    <div className="fade-up">
      <PageHeader eyebrow={`Planned · Phase ${PHASE[slug] || "—"}`} title={label(slug.replace(/-/g, "_"))} />
      <div className="flex max-w-2xl gap-4 rounded-md border border-dashed border-slate-300 bg-white p-6" data-testid="coming-soon-panel">
        <Construction className="h-6 w-6 shrink-0 text-sky-600" />
        <div className="text-sm text-slate-600">
          <p className="font-medium text-slate-800">This module is scheduled for a later delivery phase and is not yet functional.</p>
          <p className="mt-2">Until then, the corresponding lifecycle stage is tracked through the configurable workflow on each measure (transitions, required documents, approvals, tasks and audit). Upload supporting evidence in the measure's Documents tab.</p>
        </div>
      </div>
    </div>
  );
}
